import { BrowserView, MobileView, isMobile } from "react-device-detect";
import "../styles/header.scss";
import { useLocation, useNavigate } from "react-router-dom";
import {menuitems, linkitems} from "../static data/menu-items"
import { useState } from "react";
import * as Query from "../static data/queryparams";
import SocialLinks from "./social-links";
import ContactLinks from "./contact-links";
import ContactUs from "./contact-us";
import ContactUsButton from "./contact-us-button";
import ContactsCard from "../components/contacts-card";
import * as links from '../static data/sociallinks'
import LeftMenu from "./left-menu";
import { useTranslation } from "react-i18next";

export default function Header(){
 
        const { t } = useTranslation();
    const [showSubMenu, setShowSubMenu] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const [showSearch, setShowSearch] = useState(false);

    const [modalOpened,setModalOpened] = useState(false);
    const [selectedService,setSelectedService] = useState("");
    const [currentSubMenu, setCurrentSubMenu] = useState(1);

    const navigate = useNavigate();  
    const location = useLocation();

    const [showContacts, setshowcontacts] = useState(false);

    function showContactsClick(){
        setshowcontacts(true);
    }
    function hideContactsClick(){
        setshowcontacts(false);
    }   

    function CloseModal(){
        setModalOpened(false);
    }

    function goTo(i){
        if(!!(i.link)) navigate(i.link);
    }
    function goToPage(link, menu, submenu, type){
       // navigate("/apartments-search?"+Query.property + "=" + link);
        if(submenu == "Topographie")
        {
            setSelectedService(menu);
            setModalOpened(true);
            return;
        }
        navigate({
            pathname: "/apartments-search",
            search: Query.property + "=" + link +"&" + Query.offertype + "=" + type
        });
        if(location.pathname=="/apartments-search")navigate(0);
    }

    function mobileMenuClick(i,link){
        if(!!(link)) {
            if(location.pathname==link)
                navigate(0);
            else
                navigate(link);
        }
        if(currentSubMenu == i && showSubMenu)
            setShowSubMenu(false);
        else{
            setCurrentSubMenu(i);
            setShowSubMenu(true);
        }
    }

    return(
        <>
        {modalOpened ? <ContactUs service={selectedService} closeModal = {CloseModal}/> : ""}
        <div className="header">
            {/* <div className="top-header">
                <div id="imglogo" 
                onClick={()=>navigate("/")}
                >
                    <img src="logo.jpg"/>
                </div>
                <div id="logo" 
                onClick={()=>navigate("/")}
                >
                    <img src="logo main name.png"/>
                    <div id="slogan">{t('Vivez l’immobilier autrement')}</div>
                </div>
                                       
                        <div id="social-links">                            
                            <BrowserView>                            
                                <div id="contactus">Contactez-nous </div>  
                                <ContactLinks/>
                            </BrowserView>
                        </div>
                    <div id="hd-contact-info">
                        <BrowserView>                        
                            <div>
                                Email : <a href="mailto:info@lmplatinumestates.cm">info@lmplatinumestates.cm</a><br/>
                                Appels / WhatsApp : <a href="tel:+237 692 85 05 84">+237 692 85 05 84</a><br/>
                                Appels : <a href="tel:+237 651 12 50 90">+237 651 12 50 90</a> / <a href="tel:+237 658 91 74 77">+237 658 91 74 77</a><br/>
                            </div>   
                        </BrowserView>
                    </div>
                    {isMobile ? 
                        <div id="burger" onClick={()=> setShowMenu(!showMenu)}>
                            <img src="burger.svg"/>
                        </div>
                        :
                        ""
                    }
            </div> */}
            {!isMobile ?
            <>
                <div id="imglogo" 
                    onClick={()=>navigate("/")}
                    >
                        <img src="new_logo.svg"/>
                    </div>
                <div id='menu-list' style={{display:(isMobile) && !showMenu? "none" : ""}}>
                    <div style={{display:(isMobile) && !showMenu? "none" : ""}} 
                    className="menu-header" 
                    onMouseLeave={
                        ()=>{
                            setShowSubMenu(false);
                            if((isMobile)) setShowMenu(false);
                        }
                    }>
                        {menuitems.map((item,i)=>
                            <div>
                                <div id="menu-item" onMouseOver={()=>
                                    {
                                    setCurrentSubMenu(i);
                                    setShowSubMenu(true);
                                    }
                                    } onClick={()=>goTo(item)}>
                                    {t(item.name)} {i>0 ? <img src={isMobile? 'arrow-down-white.svg' : 'arrow-down.svg'}/> : ""}                                                         
                                </div>
                                {isMobile? <hr/> : ""}                                
                            </div>
                            )
                            }

                            <div style={{display:showSubMenu && menuitems[currentSubMenu].descr!="" ? "" : "none"}}
                            className={"submenu"}                                
                            >
                                {menuitems[currentSubMenu].submenu.length == 0 && !(isMobile) ?
                                    ""
                                    :
                                    <div key={menuitems[currentSubMenu].name + "s"} id = "submenuitems">
                                        {menuitems[currentSubMenu].submenu.map(x=>
                                            <>
                                                <div onClick={()=>goToPage(x.link, x.name, menuitems[currentSubMenu].name, menuitems[currentSubMenu].type)}>
                                                    {t(x.name)}
                                                </div>
                                            </>
                                        )}
                                    </div>     
                                }
                                
                                <div key={menuitems[currentSubMenu].name}
                                    className={menuitems[currentSubMenu].submenu.length == 0 && !(isMobile) ?
                                        "menu-centered-description"
                                        :
                                        ""
                                    }
                                    id="menudescription">
                                        <div className="description" id='description'>
                                            
                                        {t(menuitems[currentSubMenu].descr)}
                                        <br/>
                                        <br/>
                                        {linkitems()}
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>    
                    {!isMobile ?        
                    <div onClick={showContactsClick}>
                        <ContactUsButton/>
                    </div>
                    :""}
                </>
            :""}
            <MobileView>
                <div id="imglogo" 
                    onClick={()=>navigate("/")}
                    >
                        <img src="logo-mobile.svg"/>
                    </div>
                <div id='menu-list' style={{display:!showMenu? "none" : ""}}>
                    <div id='menu-box'>
                        <div 
                        className="menu-header">
                            {menuitems.map((item,i)=>
                                <div>
                                    <div id="menu-item" onClick={()=>
                                        {
                                            mobileMenuClick(i,item.link);
                                        }
                                        }>
                                        {t(item.name)} {i>0 ? <img 
                                        src={isMobile? 'arrow-down-white.svg' : 'arrow-down.svg'}
                                        style={{"rotate":showSubMenu && currentSubMenu==i ? "180deg" : "0deg"}}
                                        /> : ""
                                        
                                        }                                                         
                                    </div>
                                    <hr/>   
                                    {currentSubMenu == i && showSubMenu ?                                     
                                        <div id='mobile-submenu'>
                                            {menuitems[currentSubMenu].submenu.map(x=>
                                                <>
                                                    <div onClick={()=>goToPage(x.link, x.name, menuitems[currentSubMenu].name, menuitems[currentSubMenu].type)}>
                                                        <span>&#8226;</span>
                                                        <label id='item'>{t(x.name)}</label>
                                                    </div>
                                                </>
                                            )}
                                            <div id='descr'>
                                                {t(menuitems[currentSubMenu].descr)}
                                                <br/>
                                                <br/>
                                                {linkitems()}
                                            </div>
                                        </div>
                                    :""}
                                </div>
                                )
                                }
                            </div>
                            <div id='contact-us' onClick={showContactsClick}>
                                <div id="contact-us-button">
                                    <div>{t('Contact')}</div>
                                    <div><img src="small-phone-blue.svg"/></div>
                                    <div><img src="small-mail-blue.svg"/></div>
                                </div>
                            </div>
                            <div id = 'social'>
                                <a href={links.links[1].link} target="_blank">
                                    <img src='instablue.svg'/>
                                </a>
                                <a href={links.links[2].link} target="_blank">
                                <img src='facebookblue.svg'/></a>
                                <a href={links.links[4].link} target="_blank">
                                <img src='tiktokblue.svg'/></a>
                            </div>
                            <div id='white-space'></div>
                        </div>
                    </div>    
                <div id='sitename'>{t('LM PLATINUM ESTATES')}</div>
                <div id="burger" >
                    <img onClick={()=> { 
                        setShowMenu(false);
                        setShowSearch(!showSearch);                        
                    }} src={showSearch? "cross-close.svg" : "lupa.svg"}/>
                    <img onClick={()=> {
                        setShowSearch(false);
                        setShowMenu(!showMenu);
                    }} src={showMenu? "cross-close.svg" : "burger.svg"}/>
                </div>
            </MobileView>
            {showContacts ? <div className="contacts-modal">
                    <ContactsCard closeModal={hideContactsClick}/>
                 </div>
                 :
                 ""}  
        </div>
        <MobileView>
            {showSearch ? 
            <div id='left-menu-moblie'><LeftMenu/></div>
            
            :""}            
            
        </MobileView>
        </>
    )
}